import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";

import { ModalDashboardSelectComponent } from "@shared/Components/UserDashboardModalSelect/modal-dashboard-select.component";
import { UserProduct } from "@shared/Interfaces/user-products.interface";
import { UsuariosRepository } from "@shared/Repositories/usuarios.repository";

const afiRoute = "/portales/dashboard/afi";
const saludRoute = "/portales/dashboard/salud";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit {
  public isShowingUlList: boolean = true;
  public currentOption: string;
  public bsModalRef: BsModalRef;

  public products: UserProduct[] = [];

  constructor(private router: Router, private modalService: BsModalService, private usuarioRepository: UsuariosRepository) {}

  public ngOnInit(): void {
    // this.usuarioRepository.getUserProducts().subscribe((products) => {
    //   this.products = products;
    // });
    const currentRoute = this.router.url;
    if (currentRoute === afiRoute) {
      this.currentOption = "Fondos de inversión";
    } else if (currentRoute === saludRoute) {
      this.currentOption = "Salud local";
    } else {
      this.currentOption = "Riesgos generales";
    }
  }

  public setCurrentOption(selectedOption: string): string {
    this.showUlList();
    return (this.currentOption = selectedOption);
  }
  public showUlList(): void {
    this.isShowingUlList = !this.isShowingUlList;
  }
  public openConfigModal(): void {
    this.bsModalRef = this.modalService.show(ModalDashboardSelectComponent, {
      class: "modal-md",
      initialState: {
        OptionArray: this.products,
        IsFromConfiguration: true,
      },
    });
  }
}
